<div class="table-responsive">
  <table class="table dt-responsive datatables custom no-footer dtr-inline mb-0" *ngIf="columnData">
    <thead class="table-light">
      <tr>
        <ng-container *ngFor="let c of columnData">
          <th
            *ngIf="!c.hidden && c.sortable"
            class="cursor-pointer"
            [ngClass]="c.headerClasslist"
            [class.sticky-column]="c.stickyColumn"
            [style.width]="c.width"
            [style.min-width]="c.width"
            [style.max-width]="c.width"
            [sortable]="c.key"
            [direction]="sorts?.column === c.key && sorts?.direction ? sorts?.direction : ''"
            (sort)="onSort($event)"
          >
            {{ c.tKey | transloco }}
            <span class="sort-icon"></span>
          </th>

          <th
            *ngIf="!c.hidden &&
            !c.sortable"
            class="not-sort"
            [ngClass]="c.headerClasslist"
            [style.width]="c.width"
            [style.min-width]="c.width"
            [style.max-width]="c.width"
          >
            <input
              *ngIf="c.dataType === 'rowSelect'"
              class="form-check-input"
              [class.cursor-pointer]="!isSelectAllDisabled"
              [checked]="isAllRowsSelected"
              [disabled]="isSelectAllDisabled"
              (change)="onAllRowsSelect($event)"
              type="checkbox"
            />
            {{ !!c.tKey ? (c.tKey | transloco) : '' }}
          </th>
        </ng-container>

        <th
          *ngIf="actionList?.length"
          class="not-sort"
          [class.td-fixed-right]="stickyActionListColumn"
        ></th>
      </tr>
    </thead>

    <tbody>
      <ng-container *ngFor="let row of tableData; let i = index">
        <tr
          [class.cursor-pointer]="rowClickSelects"
          [class.has-row-detail]="hasRowDetailRow(row)"
          (click)="onRowClick(row, $event)"
        >
          <ng-container *ngFor="let c of columnData">
            <td
              *ngIf="!c.hidden"
              class="column-wrap"
              [class.sticky-column]="c.stickyColumn"
              [class.column-custom-width]="!!c.width"
              [style.width]="c.width"
              [style.min-width]="c.width"
              [style.max-width]="c.width"
            >
              <div
                *ngIf="c.dataType === 'number' || c.dataType ==='string' || c.dataType === 'date'"
                class="{{ c.cellClasslist }}"
                [innerHTML]="(row[c.key] ?? '') | highlight: search"
              ></div>

              <div
                *ngIf="c.dataType === 'phone'"
                class="{{ c.cellClasslist }}"
                [innerHTML]="(row[c.key] ?? '') | phoneMask | phoneHighlight:search"
              ></div>

              <div
                *ngIf="c.dataType === 'rowSelect'"
                class="{{ c.cellClasslist }}"
              >
                <input
                  class="form-check-input"
                  [class.cursor-pointer]="!c.isRowSelectable || c.isRowSelectable(row)"
                  type="checkbox"
                  [checked]="!!selectionMap.has(row.id)"
                  [disabled]="c.isRowSelectable && !c.isRowSelectable(row)"
                  [title]="c.isRowSelectable && !c.isRowSelectable(row) && c.disabledSelectTooltip ? (c.disabledSelectTooltip | transloco) : ''"
                  (change)="onRowSelect(row, $event)"
                />
              </div>

              <app-grid-cell-status
                *ngIf="c.dataType === 'status'"
                [status]="row[c.key]"
                [searchQuery]="search"
                [spinnerStatuses]="c.spinnerStatuses || []"
              ></app-grid-cell-status>

              <app-table-cell-custom-value
                *ngIf="c.dataType === 'custom' && c.customDataType"
                [dataType]="c.customDataType"
                [dataOptions]="c.customDataOptions ? c.customDataOptions(row) : null"
                [searchQuery]="search"
                [value]="row[c.key]">
              </app-table-cell-custom-value>

              <ng-container *ngIf="c.dataType === 'projectTemplate' && !!c.projectColumnTemplate">
                <ng-container *ngTemplateOutlet="c.projectColumnTemplate; context: { 'item': row }"></ng-container>
              </ng-container>
            </td>
          </ng-container>

          <td *ngIf="actionList?.length" class="column-nowrap column-action td-fixed-right">
            <app-table-cell-actions-menu
              [row]="row"
              [actionList]="actionList"
              (action)="onTableAction($event, row.id)">
            </app-table-cell-actions-menu>
          </td>
        </tr>

        <tr *ngIf="hasRowDetailRow(row)" class="row-detail">
          <td></td>
          <td [attr.colspan]="visibleColumnCount - 1">
            <div class="row-detail-collapse" [class.expanded]="selectionMap.has(row.id)">
              <div class="row-detail-body" [attr.inert]="selectionMap.has(row.id) ? null : ''">
                <div class="row-detail-content">
                  <ng-container *ngTemplateOutlet="selectedRowDetailTemplate; context: { $implicit: row }"></ng-container>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <app-table-not-found-content *ngIf="!tableData.length && !loading"></app-table-not-found-content>

  <div
    *ngIf="!hidePagination"
    class="row card-bottom card-bottom-mobile bottom-0 start-0"
    [class.position-absolute]="wrappedByCard"
  >
    <div class="d-sm-flex justify-content-sm-between">
      <ngb-pagination
        [collectionSize]="total"
        [(page)]="pageIndex"
        [pageSize]="pageSize"
        [maxSize]="maxPaginationSize"
        (pageChange)="onPagination()"
      ></ngb-pagination>

      <app-pagination-size
        (clicked)="onPagination($event)"
        [pageSize]="pageSize"
      ></app-pagination-size>
    </div>
  </div>
</div>
